var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55609 14.5884V5.0632H0.327566V14.5884H3.55609ZM1.94224 3.76192C3.06808 3.76192 3.76887 3.0305 3.76887 2.11647C3.74789 1.18182 3.06813 0.470703 1.96361 0.470703C0.859261 0.470703 0.137085 1.18184 0.137085 2.11647C0.137085 3.03054 0.837695 3.76192 1.92117 3.76192H1.94214H1.94224ZM5.34306 14.5884H8.57158V9.26905C8.57158 8.98436 8.59256 8.69998 8.67781 8.49647C8.91121 7.92769 9.44243 7.33859 10.3343 7.33859C11.5026 7.33859 11.9699 8.21207 11.9699 9.49254V14.5883H15.1982V9.12666C15.1982 6.2009 13.6055 4.83958 11.4813 4.83958C9.73963 4.83958 8.97493 5.79424 8.5501 6.44446H8.57165V5.063H5.34313C5.3855 5.95679 5.34313 14.5882 5.34313 14.5882L5.34306 14.5884Z",
    fill: "#032D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0588,
    height: 14.1176,
    fill: "white",
    transform: "translate(0.137268 0.470703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.222cf44d27bc1885c5564fbf83f8f4bf.svg";
export { ForwardRef as ReactComponent };